export const MuiTable = () => ({
  MuiTable: {
    styleOverrides: {
      root: {
        borderCollapse: "separate",
        borderSpacing: 0,
      },
    },
  },
  MuiTableContainer: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: theme.shape.borderRadius * 2,
        border: `1px solid ${theme.palette.divider}`,
        overflow: "hidden",
      }),
    },
  },
  MuiTableHead: {
    styleOverrides: {
      root: ({ theme }) => ({
        "& .MuiTableRow-root": {
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor: "transparent",
          },
        },
      }),
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderBottom: `1px solid ${theme.palette.divider}`,
        padding: "12px 16px",
        fontSize: "0.875rem",
      }),
      head: ({ theme }) => ({
        backgroundColor: "transparent",
        color: theme.palette.text.tertiary,
        fontWeight: 700,
        whiteSpace: "nowrap",
        fontSize: "0.6875rem",
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        borderBottom: `1px solid ${theme.palette.divider}`,
        position: "sticky",
        top: 0,
        zIndex: 1,
      }),
      body: ({ theme }) => ({
        fontSize: "0.875rem",
        color: theme.palette.text.primary,
      }),
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: ({ theme }) => ({
        transition: theme.transitions.create(["background-color"], {
          duration: theme.transitions.duration.short,
        }),
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
        },
      }),
    },
  },
  MuiTableBody: {
    styleOverrides: {
      root: {
        "& .MuiTableRow-root:first-of-type .MuiTableCell-root": {
          borderTop: "none",
        },
        "& .MuiTableRow-root:last-of-type .MuiTableCell-root": {
          borderBottom: "none",
        },
      },
    },
  },
});
